module.exports = __webpack_public_path__ + "assets/img/map.a37c3ee8.png";